import { render } from "./ManageOrganisationSettings.vue?vue&type=template&id=9d9b94f8&lang=pug"
import script from "./ManageOrganisationSettings.vue?vue&type=script&lang=js"
export * from "./ManageOrganisationSettings.vue?vue&type=script&lang=js"

import "./ManageOrganisationSettings.vue?vue&type=style&index=0&id=9d9b94f8&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__